export default __webpack_public_path__ + "static/media/fea4.93ccbe7b.jpg";